/**
 * Where a web step-up is allowed to send the browser back to.
 *
 * ⚠️  DEPENDENCY-FREE ON PURPOSE, like `challenge.ts` beside it. `stepUp.ts`
 *     reaches `completeOidcLogin` → `api/client` → the whole store chain, which
 *     drags in the platform-split `utils/crypto` that Jest cannot resolve. Both
 *     `oidc.ts` and `app/auth/callback.tsx` need this set, and neither should
 *     have to pull that chain — nor can `oidc.ts` import from `stepUp.ts` at
 *     all, which imports `oidc.ts`.
 *
 * ⚠️  A CLOSED SET, VALIDATED ON THE WAY BACK IN. The value round-trips through
 *     AsyncStorage — localStorage on web — so it is attacker-writable under
 *     XSS. Handing an unvalidated string straight to `router.replace` would be
 *     an open redirect into the app's own navigation. The literal union is also
 *     what expo-router's typed routes want, so a typo is a compile error rather
 *     than a silent bounce back to '/'.
 */

export const STEP_UP_RETURN_ROUTES = ['/(setup)/reset-confirm', '/(tabs)/settings'] as const;

export type StepUpReturnRoute = (typeof STEP_UP_RETURN_ROUTES)[number];

export function isStepUpReturnRoute(value: unknown): value is StepUpReturnRoute {
  return typeof value === 'string' && (STEP_UP_RETURN_ROUTES as readonly string[]).includes(value);
}
